module.exports = __webpack_public_path__ + "img/pricing-Illustration.7829c9d5.svg";